"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentStatus = /** @class */ (function () {
    function PaymentStatus(id, name) {
        this.id = id;
        this.name = name;
    }
    PaymentStatus.Unpaid = new PaymentStatus('unpaid', 'Unpaid');
    PaymentStatus.PartiallyPaid = new PaymentStatus('partially_paid', 'Partially Paid');
    PaymentStatus.FullyPaid = new PaymentStatus('fully_paid', 'Fully Paid');
    PaymentStatus.FullyRefunded = new PaymentStatus('fully_refunded', 'Fully Refunded');
    PaymentStatus.Voided = new PaymentStatus('voided', 'Voided');
    PaymentStatus.byID = function (paymentStatusID) {
        switch (paymentStatusID) {
            case PaymentStatus.Unpaid.id:
                return PaymentStatus.Unpaid;
            case PaymentStatus.PartiallyPaid.id:
                return PaymentStatus.PartiallyPaid;
            case PaymentStatus.FullyPaid.id:
                return PaymentStatus.FullyPaid;
            case PaymentStatus.FullyRefunded.id:
                return PaymentStatus.FullyRefunded;
            // case PaymentStatus.PartiallyRefunded.id:
            //   return PaymentStatus.PartiallyRefunded
            default:
                return null;
        }
    };
    PaymentStatus.All = [PaymentStatus.Unpaid, PaymentStatus.PartiallyPaid, PaymentStatus.FullyPaid, PaymentStatus.FullyRefunded];
    return PaymentStatus;
}());
exports.default = PaymentStatus;
